import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import {  Router, Route, HashRouter, BrowserRouter} from "react-router-dom";
import PrivateRoute from './components/private-route';
import EmployeeRoute from './components/employee-area/employee-route';
import { LocalizeProvider } from 'react-localize-redux';
import Login from "./components/login";
import PasswordReset from "./components/password-reset";
import Syllabus from "./components/syllabus";
import Dashboard from "./components/dashboard";
import ReportStudentAverage from "./components/reports/report-student-average";
import ReportStudentLessonAverage from "./components/reports/report-student-lesson-average";
import ReportResults from "./components/reports/report-results";
import UpdateInformation from "./components/update-information";
import ProfileUpdate from "./components/profile-update";
import LandingPage from "./components/landing-page";
import DownloadPage from "./components/download-page";
import SubscriptionDownload from "./components/forms/form-subscription-download";
import ChatroomEmployee from "./components/employee-area/chat-employee";
import DashboardEmployee from "./components/employee-area/dashboard-employee";
import LoginEmployee from "./components/employee-area/login-employee";
import SubscriptionManager from "./components/employee-area/subscription-manager";
import PlansManager from "./components/employee-area/plans-manager";
import PlansSearch from "./components/employee-area/plans-search";
import SubscriptionsSearch from "./components/employee-area/subscriptions-search";
import SinglePageSubscription from "./components/single-page-subscription";
import SubscriptionAddNew from "./components/subscription-add-new";
import ScrollToTop from 'react-router-scroll-top';
import PlanSelect from './components/plan-select';
import SubscriptionSetProfileFirstTime from './components/subscription-set-profile-first-time';
import SubscriptionSetProfileExistingAccount from './components/subscription-set-profile-existing-account';
import DownloadFirstTime from './components/download-first-time';
import Coupons from './components/employee-area/coupons';
import UsersSearch from './components/employee-area/users-search';
import Reports from './components/employee-area/report-area';
import ReportSubscriptions from './components/employee-area/report-subscriptions';
import ReportClients from './components/employee-area/report-clients';
import ReportUsage from './components/employee-area/report-usage';
import AccountAccessRecovery from './components/account-access-recovery';

class App extends React.Component {

    render() {
        return (
            /** Set the routes of each page with the renders **/

            <LocalizeProvider>
                <HashRouter basename={'/genial-web'}>
                    <ScrollToTop>
                    <div>
                        <Route push exact path="/" component={LandingPage}/>
                        <Route push path="/download" component={DownloadPage}/>
                        <Route push path="/login" component={Login}/>
                        <Route push path="/password-reset" component={PasswordReset}/>
                        <Route push path="/subscription-download" component={SubscriptionDownload}/>
                        <Route push path="/login-employee" component={LoginEmployee}/>
                        <Route push path="/subscribe" component={SinglePageSubscription}/>
                        <Route push path="/select-plan" component={PlanSelect}/>
                        <Route push path="/account-access-recovery" component={AccountAccessRecovery}/>

                        {/* Stablish the private routes. The user should be */}
                        <PrivateRoute path="/subscription-add-new" component={SubscriptionAddNew}/>
                        <PrivateRoute path="/syllabus" component={Syllabus}/>
                        <PrivateRoute push path="/dashboard" component={Dashboard} />
                        <PrivateRoute path="/report-average" component={ReportStudentAverage}/>
                        <PrivateRoute path="/report-lesson-average" component={ReportStudentLessonAverage}/>
                        <PrivateRoute path="/report-results" component={ReportResults}/>
                        <PrivateRoute path="/update-information" component={UpdateInformation}/>
                        <PrivateRoute path="/profile-update" component={ProfileUpdate}/>
                        <PrivateRoute path="/set-up-child-profile" component={SubscriptionSetProfileFirstTime}/>
                        <PrivateRoute path="/add-child-profile" component={SubscriptionSetProfileExistingAccount}/>
                        <PrivateRoute path="/download-first-time" component={DownloadFirstTime}/>

                        {/*Employee areas **/}
                        <EmployeeRoute push path="/dashboard-employee" component={DashboardEmployee}/>
                        <EmployeeRoute path="/chatroom" component={ChatroomEmployee}/>
                        <EmployeeRoute push path="/subscription-manager" component={SubscriptionManager}/>
                        <EmployeeRoute push path="/plans-manager" component={PlansManager}/>
                        <EmployeeRoute push path="/plans-search" component={PlansSearch}/>
                        <EmployeeRoute push path="/subscriptions-search" component={SubscriptionsSearch}/>
                        <EmployeeRoute push path="/coupons" component={Coupons}/>
                        <EmployeeRoute push path="/users-search" component={UsersSearch}/>
                        <EmployeeRoute push path="/reports" component={Reports}/>
                        <EmployeeRoute push path="/report-subscriptions" component={ReportSubscriptions}/>
                        <EmployeeRoute push path="/report-clients" component={ReportClients}/>
                        <EmployeeRoute push path="/report-usage" component={ReportUsage}/>
                        </div>
                        </ScrollToTop>
                </HashRouter>
            </LocalizeProvider>
        )
    };
}
/** Exact prop is for match exactly at it is. For example /login is valid, /login/2 is not valid**/

// Set the router as Main APP so the app know where it can go
ReactDOM.render(<App />, document.getElementById("root"));